import { render } from "./eventDetail.vue?vue&type=template&id=c18b4e66&scoped=true"
import script from "./eventDetail.vue?vue&type=script&lang=js"
export * from "./eventDetail.vue?vue&type=script&lang=js"

import "./eventDetail.vue?vue&type=style&index=0&id=c18b4e66&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18b4e66"]])

export default __exports__